import React from 'react'

class SeasonListDropdownView extends React.Component {
	render(){
		const {seasonNames, currentSeason} = this.props
		const totalSeasons = this.props.seasonNames.length
		return(
			<select className="season-list-dropdown-view site-color" onChange={e => this.props.handleChange(e)} defaultValue={currentSeason}>
				{seasonNames.map((seasonName, key) => (
					<option 
						value={parseInt(totalSeasons - (key + 1), 10)} 
						key={totalSeasons - (key + 1)}
						data-season={totalSeasons - (key + 1)}>
						{seasonName || `Season ${key + 1}`}
					</option>
				))}
			</select>
		)
	}
}
export default SeasonListDropdownView;